import React from 'react'
import Contactus from '../Common/Contactus'
import MainBanner from '../page_content/MainBanner'
import whiterightarrow from "../../assets/images/white-rightarrow.svg";
import blackrightarrow from "../../assets/images/blackrightarrow.svg";
import sideCartimg from "../../assets/images/realstateimg.png";
import closeicon from "../../assets/images/closeicon.svg";
import Header from '../Common/Header';
const Realstate = () => {
    return (
        <>
            <Header />

            <div>
                <MainBanner page="PRODUCTS" />
                <section className=" aboutsection2" id="single-product">
                    <div className="container ">
                        <div className="bg-white">
                            <div className="text-section">
                                <h2 className="text-purple">
                                    Real Estate
                                </h2>
                                <p className="fw-medium">Property </p>
                                <div>
                                    Online Marketplace:&nbsp;The Real Estate Website Project is designed to create a modern, user-friendly platform that connects property buyers, sellers, renters, and real estate agents. The website will serve as a comprehensive resource for finding residential, commercial, and rental properties, offering a seamless experience for users to browse listings, schedule viewings, and manage real estate transactions.



                                </div>
                                <div>
                                    Product Catalogue:&nbsp;
                                    The platform will feature detailed property listings with high-quality images, virtual tours, and comprehensive descriptions, allowing users to explore properties from the comfort of their homes. Advanced search filters will enable users to refine their search based on location, price, property type, and amenities, ensuring they find the perfect match for their needs.


                                </div>
                                <div className="d-flex">
                                    <a
                                        href="#demo-modal"
                                        className="btn btn-black btn-purple  text-white"
                                    >
                                        View Project
                                        <img src={whiterightarrow} alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="image-section">
                                <img src={sideCartimg} alt="" />
                            </div>
                        </div>
                        <div id="demo-modal" className="modal">
                            <div className="modal__content">
                                <h2 className="text-purple">Get A Free Demo</h2>
                                <p className="fw-medium">
                                    Embrace Opportunity: A Pathway to Success
                                </p>
                                <div className="form-container">
                                    <div className="form-group">
                                        <label htmlFor="product">Select Product:</label>
                                        <select id="product" name="product">
                                            <option value="product1">Comercio</option>
                                            <option value="product2">Product 2</option>
                                            <option value="product3">Product 3</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Name:</label>
                                        <input
                                            type="text"
                                            id="name"
                                            placeholder="MCL"
                                            name="name"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Email:</label>
                                        <input
                                            type="email"
                                            placeholder="info@gmail.com"
                                            id="email"
                                            name="email"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone:</label>
                                        <input
                                            type="tel"
                                            placeholder="+91 9896570012"
                                            id="phone"
                                            name="phone"
                                            required
                                        />
                                    </div>
                                    <div className="form-group full-width">
                                        <label htmlFor="message">Message:</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            placeholder="Enter your message here"
                                            required
                                            defaultValue={""}
                                        />
                                    </div>
                                    <div className="form-group full-width button">
                                        <button className="btn btn-black" type="submit">
                                            Get a demo
                                        </button>
                                    </div>
                                </div>
                                <a href="#" className="modal__close">
                                    <img src={closeicon} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className id="Comercio-discription">
                    <div className="container ">
                        <div className="card-container bg-white text-gray">
                            <div>
                                <span className="fw-semi-bold">
                                    Comprehensive Property Listings:
                                    &nbsp;</span>
                                The platform features detailed listings for residential, commercial, and rental properties, complete with high-quality images, virtual tours, and comprehensive descriptions.


                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                    Advanced Search Filters:
                                </span>
                                Users can easily refine their property search based on criteria such as location, price, property type, and amenities, ensuring a tailored experience that meets their needs.

                            </div>
                            <div>
                                <span className="fw-semi-bold">Agent and Seller Tools:
                                    &nbsp;</span>
                                Real estate agents and sellers can create and manage property listings, track inquiries, and monitor potential leads, streamlining the selling process.

                            </div>

                        </div>
                        <div className="card-container bg-white text-gray">
                            <div>
                                <span className="fw-semi-bold">

                                    Automated Listing Alerts:


                                    &nbsp;
                                </span>
                                Buyers and renters can set up alerts for new listings that match their preferences, ensuring they are notified promptly about available properties.

                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                    Market Insights and Resources:


                                    &nbsp;
                                </span>
                                &nbsp;The website includes a blog section that offers valuable insights, tips, and legal guidance related to the real estate market, helping users make informed decisions.


                            </div>
                            <div>
                                <span className="fw-semi-bold">

                                    Mobile Optimization and Security:&nbsp;&nbsp;
                                </span>
                                &nbsp;The platform is optimized for mobile devices, providing a seamless user experience, while ensuring secure transactions and data protection for all users involved.


                            </div>
                        </div>
                    </div>
                </section>
                <Contactus />
            </div></>
    )
}

export default Realstate